import Hero from './components/Hero';
import CTASection from './components/CTASection';
import CategoryCards from './components/CategoryCards';
import ArticleGrid from './components/ArticleGrid';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL;
const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: 'Kakobuy Finds',
      url: siteUrl,
      logo: logoUrl,
      description: 'Kompletna baza zweryfikowanych produktów z Chin – Kakobuy Spreadsheet 2026. Najlepsze znaleziska zakupowe dla Polski i Europy.',
      sameAs: [
        'https://kaspreadsheet.com',
      ],
    },
    {
      '@type': 'WebSite',
      name: 'Kakobuy Finds',
      url: siteUrl,
      description: 'Kakobuy Spreadsheet 2026 – kompletna baza zweryfikowanych produktów z Chin. Znajdź najlepsze Kakobuy Finds w jednym arkuszu.',
      inLanguage: 'pl',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${siteUrl}/blog/{slug}`,
        },
        'query-input': 'required name=slug',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={homeJsonLd} />
      <main>
        <Hero />
        <CTASection />
        <CategoryCards />
        <ArticleGrid />
        <AboutSection />
        <TestimonialSection />
      </main>

      <Footer />
    </>
  );
}